import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import OurApproach from "@/pages/OurApproach";
import Courses from "@/pages/Courses";
import OnCountry from "@/pages/OnCountry";
import SeedBanks from "@/pages/SeedBanks";
import ForOrganisations from "@/pages/ForOrganisations";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Library from "@/pages/Library";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <SmoothScroll>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/approach" element={<OurApproach />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/on-country" element={<OnCountry />} />
                <Route path="/seed-banks" element={<SeedBanks />} />
                <Route path="/organisations" element={<ForOrganisations />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/library" element={<Library />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </SmoothScroll>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
